import React from "react";
import PropertyCard from "./PropertyCard";
import "./FeaturedProperties.css";

function FeaturedProperties() {
  return (
    <div className="FeaturedProperties">
      <div className="FeaturedProperties__title">
        <h1>Featured properties</h1>
      </div>
      <div className="FeaturedProperties__subtitle">
        <p>
          View highlighted properties currently listed with Luxury Spain
          Properties
        </p>
      </div>
      <div className="FeaturedProperties__cards">
        <PropertyCard
          img="https://i.postimg.cc/vTSYpfN4/Frame-63-4.png"
          name="Luxury Modern Villa Project"
          location="Benissa - SPAIN"
          price="2,600,000€"
          bedrooms="4"
          bathrooms="4"
          housesize="569 m²"
         status=""
         badgecolor=""
          slug="LUXURY_MODERN_VILLA_PROJECT_BENISSA_COSTA_BLANCA_SPAIN_CFP-P1013"
        />

        <PropertyCard
         img="https://i.postimg.cc/V6vjyQf4/Frame-63-5.png"
         name="Luxury Modern Villa Cucarres"
         location="Calpe - SPAIN"
         price="1,950,000€"
         bedrooms="4"
         bathrooms="5"
         housesize="411 m²"
       status=""
         badgecolor=""
         slug="LUXURY_MODERN_VILLA_CUCARRES_CALPE_COSTA_BLANCA_SPAIN_CFP-P1015"
        />

        <PropertyCard
         img="https://i.postimg.cc/13TH93d2/Frame-63-6.png"
         name="Modern Luxury Villa"
         location="Altea - SPAIN"
         price="2,093,650€"
         bedrooms="4"
         bathrooms="6"
         housesize="535 m²"
      status=""
         badgecolor=""
         slug="MODERN_LUXURY_VILLA_ALTEA_COSTA_BLANCA_SPAIN_CFP-M2017"
        />

        <PropertyCard
          img="https://i.postimg.cc/wjcxhwKk/Frame-63.png"
          name="Modern Luxury Villa"
          location="Benissa - SPAIN"
          price="990,000€"
          bedrooms="3"
          bathrooms="3"
          housesize="251,50 m²"
        status=""
         badgecolor=""
          slug="LUXURY_MODERN_VILLA_BENISSA_COSTA_BLANCA_SPAIN_CFP-M2015"
        />
      </div>
      <div className="FeaturedProperties__viewmore">
        <a href="/properties">
          <p>View more</p>
        </a>
      </div>
    </div>
  );
}

export default FeaturedProperties;
